import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "panel", "content"];

  show(event) {
    const row = event.currentTarget.closest("tr");
    const data = JSON.parse(row.dataset.trackingDetail);

    this.contentTarget.innerHTML = this._buildDetail(data);
    this.overlayTarget.classList.remove("hidden");
    this.panelTarget.classList.remove("translate-x-full");
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
    this.overlayTarget.classList.add("hidden");
  }

  // Private

  _buildDetail(d) {
    const rows = [
      ["Date", d.date],
      ["User", d.email],
      ["IP Address", d.ip_address],
      ["User Agent", d.user_agent],
      ["Referrer", d.referrer],
      ["UTM Source", d.utm_source],
      ["UTM Medium", d.utm_medium],
      ["UTM Campaign", d.utm_campaign],
      ["UTM Content", d.utm_content],
      ["UTM Term", d.utm_term],
      ["gclid", d.gclid],
      ["fbp", d.fbp],
      ["fbc", d.fbc],
    ];

    const tableRows = rows
      .map(([label, value]) => {
        const display = value || "-";
        return `<tr>
          <td class="text-base-content/60 whitespace-nowrap">${label}</td>
          <td class="text-right font-mono text-xs break-all">${this._escapeHtml(display)}</td>
        </tr>`;
      })
      .join("");

    return `<table class="table table-md"><tbody>${tableRows}</tbody></table>`;
  }

  _escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
